export const QUICK_SEARCH_ROUTE = '/search/quick';
export const QUICK_SEARCH_ROUTES = {
  QUERY: `${QUICK_SEARCH_ROUTE}/query`,
  RESULTS: `${QUICK_SEARCH_ROUTE}/results`,
};
